
import moment from 'moment';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import productPromotionQuery from '~/apollo/queries/product/productPromotion.gql';

export default {
  name: "QdapHomeProductCardPromotionDetail",
  mixins: [eventTrackingMixins],
  props: {
    data: {
        type: Object,
        default: () => ({})
    }
  },

  data() {
    return {
      promotion: null,
      loading: 0,
      isShowTermsAndConditions: false
    };
  },
  // page component definitions
  apollo: {
    promotion: {
      query: productPromotionQuery,
      prefetch: true,
      variables() {
        return {
          id: parseInt(this.promotionId),
          currentlocale: this.$normalizeLocale(this.$i18n.locale)
        };
      },
      update(data) {
        return this.$normalizeStrapi(data.productPromotions.data[0]);
      }
    }
  },

  methods: {
    handleEventTracking_modalPromotionContent(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target);
      const href = dataFromClickedElement?.href;

      if (dataFromClickedElement.tracking_target.target_code === 'product-promo-modal-cta') {
        if (this.isTransitionLink(href)) {

          // #195  {landing_url}	click_redirection	qdap_{insurer name}_hyperlink_{hyperlink} 
          const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
          const insurerCode = this.data?.insurerCode
          const href = dataFromClickedElement?.href
          const productName = this.data?.productName;
          const eventTrackingParams = this.initEventTrackingParams()
          eventTrackingParams.a = 'click_redirection'
          eventTrackingParams.l = `${href}`
          eventTrackingParams.c = `qdap_${insurerCode}_hyperlink_${href}`
          eventTrackingParams.cd.product_category = `QDAP`
          eventTrackingParams.cd.product_name = productName
          eventTrackingParams.cd.insurer_name = `${insurerCode}`
          this.sendEventTracking(eventTrackingParams)
        } 
      }
    },

    showTermsAndConditions() {
      this.isShowTermsAndConditions = !this.isShowTermsAndConditions;
    }
  },
};
